import React from 'react';
import { Page as CorePage } from 'js/components/system/Page/Page';
import { UserVerificationBanner } from './components/UserVerificationBanner';
import { AboveMainContent } from './components/AboveMainContent';

export const Page = ({ path, ...rest }) => {

    return (
        <>
            <AboveMainContent />
            <CorePage path={path} { ...rest } />
            <UserVerificationBanner path={path}/>
        </>
    );
};
